export const environment = {
  domain: 'sandbox',
  hsId: 23538888,
  disablev6: true,
  production: false,
  originDomain: 'sandbox-nfconsole.io', // Allowed Origin in auth0 (root domain)
  originPort: false,
  gatewayUrl: 'gateway.sandbox.netfoundry.io',
  apiUrl: 'https://gateway.sandbox.netfoundry.io/rest/v1/',
  clientSyncsApiUlr: 'https://gateway.sandbox.netfoundry.io/clientsync/v1/',
  netflowUrl: 'https://gateway.sandbox.netfoundry.io/netflow/v1/',
  downloadsURL: 'https://netfoundry.io/resources/support/downloads/networkversion',
  customerURL: 'https://gateway.sandbox.netfoundry.io/customer/v1/',
  appsURL: 'https://gateway.sandbox.netfoundry.io/apps/v1/',
  bannerURL: 'https://gateway.sandbox.netfoundry.io/banner/v1/',
  kibanaURL: 'https://kibana-sandbox-internal-netfoundry-io.kb.us-east-1.aws.found.io:9243/',
  elasticConfig: {
    usePublicApi: true,
    reportingServiceUrl: 'https://gateway.sandbox.netfoundry.io/reporting/v1/elastic',
    reportingServiceEnabled: true,
    reportingTemplateServiceUrl: 'https://gateway.sandbox.netfoundry.io/reporting/v1/template-search',
  },
  defaultNetworkConfigName: 'medium',
  defaultSize: 'medium',
  defaultLocationCode: 'us-east-1',
  authconfig: {
    clientID: '6WXzPe5Zu3Z0VjJDbwZcsZ71JeGRDJOp',
    domain: 'netfoundry-sandbox.auth0.com',
    callbackURL: 'https://sinec.sandbox-nfconsole.io/callback',
    // Namespace for where the organization ID is stored in the auth token
    jwtOrgKey: 'https://netfoundry.io/organization_id',
    audience: 'https://gateway.sandbox.netfoundry.io/',
    newSignupRedirect: 'https://sinec.sandbox-nfconsole.io/signup-return',
  },
  identityConfig: {
    url: 'https://gateway.sandbox.netfoundry.io/identity/v1/',
    invitationUrl: 'https://sinec.sandbox-nfconsole.io/invitation',
    intermediateReturnUrl: 'https://sinec.sandbox-nfconsole.io/invitation',
    registrationReturnUrl: 'https://sinec.sandbox-nfconsole.io/signup',
    loginReturnUrl: 'https://sinec.sandbox-nfconsole.io/login',
  },
  billingConfig: {
    // this is subject to change
    billingUrl: 'https://gateway.sandbox.netfoundry.io/billing/v1/',
    // stripe sandbox environment
    stripe: 'pk_live_JVRJaDMuJC0g13wm66FRjviY',
  },
  chargebeeConfig: {
    // this is subject to change
    site: 'netfoundry',
    // chargebee sandbox environment
    publishableKey: 'live_VrWGPcdgqqmAt7sjcuvt7YRfdTnXXn4AHw',
  },
  // temporary property for the how long the session timeout should be. This should get replaced once the API supports session timeout
  defaultSessionTimeoutSeconds: 1800,
  // temporary property for how long before the session timeout the user should be warned about the timeout
  defaultTimeoutWarningSeconds: 60,
  // two hour timeout for endpoint session users
  endpointSessionTimeoutSeconds: 43200,
  pageSize: 30,
  // list of comma separated email ids of test robots. If the current profile's email id is matching with any of the given test user
  // email ids, then some of the functionalities will be hidden or diabled.
  internalTestUserEmailIds: 'nf_test1@netfoundry.io',
  authorizationUrl: 'https://gateway.sandbox.netfoundry.io/auth/v1/',
  reportingUrl: 'https://gateway.sandbox.netfoundry.io/reports/v1',
  gtmLink:
    'https://www.googletagmanager.com/ns.html?id=GTM-TG778K4&gtm_auth=_q0-lGoQ-Myz8lj8MZVmGQ&gtm_preview=env-18&gtm_cookies_win=x',
  v2apiUrl: 'https://gateway.sandbox.netfoundry.io/core/v2/',
  v3apiUrl: 'https://gateway.sandbox.netfoundry.io/core/v3/',
  notificationUrl: 'https://gateway.sandbox.netfoundry.io/notification/v1',
  registrationIp: '184.72.146.130, 35.175.23.123',
  // TODO: remove when MOP can handle custom timeouts
  pldtTimeoutSeconds: 32000,
  pldtId: 'a37f806b-4f49-48f2-aa28-d850d5f24b8c',
  sampleServiceUrl: 'https://sample.tools.netfoundry.io',
  hideSubmitTicket: true,
  hideZiggy: true,
  showDefaultLogo: true,
  enableCustomLoadingIndicator: true,
  titleName: 'Siemens',
  gatewayApiUrl: 'https://gateway.sandbox.netfoundry.io/',
  orgId: '900F87E4-F819-4D90-83FA-0C74D27A7CAE',
  alwaysVanityUrl: true,
  realmsSupported: true,
};
